import { render, staticRenderFns } from "./travelCompents.vue?vue&type=template&id=14a53c24&scoped=true&"
import script from "./travelCompents.vue?vue&type=script&lang=js&"
export * from "./travelCompents.vue?vue&type=script&lang=js&"
import style0 from "./travelCompents.vue?vue&type=style&index=0&id=14a53c24&lang=less&scoped=true&"
import style1 from "./travelCompents.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a53c24",
  null
  
)

component.options.__file = "travelCompents.vue"
export default component.exports